<template>
  <table class="table-riwayat text-sm">
    <thead>
      <tr>
        <th class="title w-[140px] py-5 px-3 text-left" rowspan="2">Tanggal & Lokasi Survei</th>
        <th class="py-5 px-1 text-center border-r-[1px] border-black min-w-[165px] bg-[#E0E0E0]" :colspan="columnGroup.healthSign.length || ''">
          <span class="text-sm font-semibold">Tanda Kesehatan</span>
        </th>
        <th class="py-5 px-1 text-center bg-[#979797]" :colspan="columnGroup.risk.length || ''">
          <span class="text-sm text-white font-semibold">Beresiko</span>
        </th>
      </tr>
      <tr>
        <td v-for="(item, index) in columnGroup.healthSign" :key="`healthSign-${item.menu}`" class="healthSign icon-table w-[70px] py-4 px-1 text-center" :class="index === columnGroup.healthSign.length-1 && '!border-r-black'">
          <img :src="item.icon" :alt="item.title" class="w-[20px] h-[20px] object-contain m-auto mb-2">
          <span class="text-xxs">{{item.title }}</span>
        </td>
        <td v-for="item in columnGroup.risk" :key="`risk-${item.menu}`" class="icon-table risk w-[70px] py-4 px-1 text-center">
          <img :src="item.icon" :alt="item.title" class="w-[20px] h-[20px] object-contain m-auto mb-2">
          <span class="text-xxs">{{item.title }}</span>
        </td>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in currentData" :key="`table-${index}`">
        <td class="py-5 px-3">
          <span class="font-normal block text-sm">{{ formatDashDate(item.date) }}</span>
          <span class="block text-base font-semibold">{{ item.activity?.name || '-' }}</span>
          <router-link :to="`/result?token=${encodeURIComponent(token)}&page=${index+1}`">
            <span class="block text-info underline text-xs mt-2">
              Lihat Detail <ArrowRightIcon color="#1C7DCA" class="w-4 h-4 inline-block ms-3"/>
            </span>
          </router-link>
        </td>
        <td v-for="(item2, index2) in columnGroup.healthSign" :key="`healthSignItem-${item2.menu}`" class="py-5 px-1" :class="index2 === columnGroup.healthSign.length-1 && '!border-r-black'">
          <Circle v-if="statusByRow[index][item2.menu]" class="w-6 h-6 mx-auto" :class="`bg-${statusByRow[index][item2.menu]}-dark`"/>
          <div v-else class="w-[20px] h-[1px] border-t-2 border-[#343434] mx-auto"></div>
        </td>
        <td v-for="item2 in columnGroup.risk" :key="`riskItem-${item2.menu}`" class="risk py-5 px-1">
          <Circle v-if="statusByRow[index][item2.menu]" class="w-6 h-6 mx-auto" :class="`bg-${statusByRow[index][item2.menu]}-dark`"/>
          <div v-else class="w-[20px] h-[1px] border-t-2 border-[#343434] mx-auto"></div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import { formatDashDate } from '@/utilities/helpers';
</script>

<script>
import Circle from '@/components/icons/Circle.vue';
import ArrowRightIcon from '@/components/icons/ArrowRight.vue';
import { getHealthSignTitle, getRiskTitle, lifeStageType } from '@/utilities/constants';

const VALID_STATUSES = ['normal', 'warning', 'danger'];

const ICON_BY_MENU = {
  malariaControl: 'ic_malaria.svg',
  kia: 'ic_ruler.svg',
  bmi: 'ic_imt.svg',
  mentalHealth: 'ic_ruler.svg',
  malaria: 'ic_malaria.svg',
  armCircum: 'ic_ruler.svg',
  bloodPressure: 'ic_heart.svg',
  temp: 'ic_termometer.svg',
  pregnancyInterval: 'ic_ruler.svg',
  pregnancyCheckUp: 'ic_ruler.svg',
  pregnancyClass: 'ic_ruler.svg',
  pregnancyRisk: 'ic_imt.svg',
  nutrition: 'ic_ruler.svg',
  breastfeed: 'ic_ruler.svg',
  postpartumCheckUp: 'ic_imt.svg',
  postpartumRisk: 'ic_imt.svg',
  babyRisk: 'ic_pacifier.svg',
  postnatalCheckUp: 'ic_imt.svg',
  immunization: 'ic_ruler.svg',
  imunization: 'ic_ruler.svg',
  weightHeight: 'ic_weight.svg',
  anemia: 'ic_heart.svg',
  childRisk: 'ic_pacifier.svg',
  headCircum: 'ic_head.svg',
  height: 'ic_height.svg',
  weight: 'ic_weight.svg',
  contraception: 'ic_ruler.svg',
  house: 'ic_star.svg',
  family: 'ic_star.svg',
  smokingHabbit: 'ic_cigarette.svg',
  hypertensionControl: 'ic_heart.svg',
  tbcControl: 'ic_tbc.svg',
  bloodSugar: 'ic_rain_drop.svg',
  waistCircum: 'ic_ruler.svg',
  diabetesControl: 'ic_rain_drop.svg',
  tbcIdentification: 'ic_tbc.svg',
  ppok: 'ic_head.svg',
  geriatric: 'ic_ruler.svg',
  skilas: 'ic_skilas.svg',
  aks: 'ic_aks.svg',
  covid: 'ic_star.svg',
  babyGrowth: 'ic_star.svg',
  sense: 'ic_star.svg',
  screeningNutrition: 'ic_star.svg',
  screeningBloodPressure: 'ic_star.svg',
  screeningBloodSugar: 'ic_star.svg',
  victimOfViolence: 'ic_star.svg',
  drug: 'ic_star.svg',
  trackingAks: 'ic_star.svg',
  senseHistory: 'ic_star.svg',
  mouth: 'ic_star.svg',
  ear: 'ic_star.svg',
  eye: 'ic_star.svg',
  cancer: 'ic_star.svg',
  trackingSkilas: 'ic_star.svg',
  growth: 'ic_star.svg',
};

function iconPath(menu) {
  return `/tab-icons/${ICON_BY_MENU[menu] || 'ic_star.svg'}`;
}

export default {
  name: 'TableHistory',
  components: {
    Circle,
    ArrowRightIcon,
  },
  props: {
    currentData: {
      type: Array,
      default: () => ([]),
    },
    token: {
      type: String,
      default: '',
    },
  },
  computed: {
    statusByRow() {
      return this.currentData.map((item) => (item.results || []).reduce((acc, obj) => {
        if (VALID_STATUSES.includes(obj.status)) {
          acc[obj.menu] = obj.status;
        }
        return acc;
      }, {}));
    },
    lifeStageString() {
      const [firstItem = {}] = this.currentData;
      return lifeStageType(firstItem.lifeStage, firstItem.pregnancyStatus);
    },
    columnGroup() {
      const groups = {
        healthSign: [],
        risk: [],
      };
      const menus = {
        healthSign: new Set(),
        risk: new Set(),
      };

      this.currentData.forEach((item) => {
        (item.results || []).forEach((result) => {
          if (!menus[result.type] || menus[result.type].has(result.menu)) {
            return;
          }

          menus[result.type].add(result.menu);
          groups[result.type].push({
            menu: result.menu,
            type: result.type,
            icon: iconPath(result.menu),
            title: result.menu,
          });
        });
      });

      const healthSignColumns = groups.healthSign.reverse();
      const healthSignTitles = getHealthSignTitle(healthSignColumns, this.lifeStageString);
      const riskTitles = getRiskTitle(groups.risk, this.lifeStageString);

      return {
        healthSign: healthSignColumns.map((item, index) => ({
          ...item,
          title: healthSignTitles[index] || item.menu,
        })),
        risk: groups.risk.map((item, index) => ({
          ...item,
          title: riskTitles[index] || item.menu,
        })),
      };
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
